import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { lenisRef } from "@/lib/lenis";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.12, anchors: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            lenisRef.current = null;
        };
    }, []);

    return (
        <div className="App">
            <SiteProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <ScrollManager />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                        <Toaster position="bottom-right" richColors />
                    </BrowserRouter>
                </AuthProvider>
            </SiteProvider>
        </div>
    );
}

export default App;
